import React from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { Inbox, FlaskConical, FileText, LogOut, ArrowUpRight, ShieldAlert } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const NAV = [
  { to: "/admin", label: "Enquiries", icon: Inbox, end: true },
  { to: "/admin/cupping", label: "Cupping", icon: FlaskConical },
  { to: "/admin/offers", label: "Offers", icon: FileText }
];

export default function AdminLayout() {
  const { user, logout } = useAuth();

  if (!user?.is_admin) {
    return (
      <main className="min-h-screen bg-[#10271a] text-[#f6f1e7] flex items-center justify-center px-6" data-testid="admin-forbidden">
        <div className="max-w-md text-center">
          <ShieldAlert className="mx-auto text-[#b08a5f]" size={36} />
          <h1 className="mt-6 font-display text-3xl font-light">This account isn't authorised.</h1>
          <p className="mt-3 text-[#f6f1e7]/70">You're signed in as {user?.email}. The trade desk is restricted to Leslie West Africa accounts.</p>
          <button type="button" onClick={logout} data-testid="admin-logout" className="mt-8 bg-[#f6f1e7] text-[#10271a] px-6 py-3 rounded-full text-sm tracking-[0.12em] uppercase font-semibold">Sign out</button>
        </div>
      </main>
    );
  }

  return (
    <div className="min-h-screen bg-[#ece2cf] md:grid md:grid-cols-[260px_1fr]" data-testid="admin-layout">
      <aside className="bg-[#10271a] text-[#f6f1e7] p-6 md:p-8 md:min-h-screen flex md:flex-col gap-6 md:gap-0 items-center md:items-stretch justify-between">
        <div>
          <Link to="/trading/coffee"><img src="/logo-white.png" alt="Leslie West Africa" className="h-10 w-auto" /></Link>
          <p className="hidden md:block mt-8 text-[#b08a5f] text-[11px] tracking-[0.25em] uppercase">Trade desk</p>
          <nav className="mt-2 md:mt-4 flex md:flex-col gap-1">
            {NAV.map(({ to, label, icon: Icon, end }) => (
              <NavLink key={to} to={to} end={end} data-testid={`admin-nav-${label.toLowerCase()}`}
                className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm transition-colors ${isActive ? "bg-[#f6f1e7] text-[#10271a]" : "text-[#f6f1e7]/75 hover:bg-[#f6f1e7]/10"}`}>
                <Icon size={16} /> <span className="hidden sm:inline">{label}</span>
              </NavLink>
            ))}
          </nav>
        </div>
        <div className="md:mt-auto flex md:flex-col items-center md:items-stretch gap-3">
          <Link to="/trading/coffee" className="hidden md:inline-flex items-center gap-2 text-xs text-[#f6f1e7]/60 hover:text-[#f6f1e7]">View site <ArrowUpRight size={14} /></Link>
          <div className="hidden md:block text-xs text-[#f6f1e7]/60 truncate">{user.email}</div>
          <button type="button" onClick={logout} data-testid="admin-logout" className="inline-flex items-center gap-2 text-xs tracking-[0.12em] uppercase font-semibold text-[#f6f1e7]/80 hover:text-[#f6f1e7]"><LogOut size={14} /> <span className="hidden sm:inline">Sign out</span></button>
        </div>
      </aside>
      <section className="p-6 md:p-12 overflow-x-hidden">
        <Outlet />
      </section>
    </div>
  );
}
